// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__o1MQD","filesListContainer":"PosDisputesFiles_filesListContainer__2YDAA","filesButton":"PosDisputesFiles_filesButton__3d0vz"};